module.exports = __webpack_public_path__ + "assets/icon-green-check.15d12e4f.svg";